<template>
  <div style="background:#f8ad9d;">
    <v-container>
      <v-carousel
        cycle
        height="20vw"
        hide-delimiter-background
        show-arrows-on-hover
      >
        <v-carousel-item v-for="(slide, i) in slides" :key="i">
          <!--           <v-sheet :color="colors[i]" height="100%" :src="require(slide)">
            <v-row class="fill-height" align="center" justify="center">
              <div class="display-3">{{ slide }} Slide</div>
            </v-row>
          </v-sheet> -->
          <v-card class="mx-auto">
            <v-img
              eager
              :src="'https://source.unsplash.com/1600x900/?travel' + i"
            ></v-img>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: [
        "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
        "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
        "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
        "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
        "https://cdn.vuetifyjs.com/images/parallax/material.jpg"
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"]
    };
  }
};
</script>
